export const formatPercentage = (value: string | number, decimalPlaces = 2): string => {
  const numericValue = Number(value);

  if (!Number.isFinite(numericValue)) {
    return '-';
  }

  return `${(numericValue * 100).toFixed(decimalPlaces)}%`;
};
